<template>
  <div class="shop_list">
    <div class="topBar">
      <div class="subTitle">
        <i
          class="far fa-window-minimize"
          style="transform:rotate(90deg);margin-right: -10px;color:rgba(52,152,219,1);"
        ></i>
        用户列表
        <div class="rutun">
          <div>
            <i class="fas fa-sync-alt"></i>
          </div>
          <div style="margin-left:4px" @click="geting()">刷新</div>
        </div>
      </div>
    </div>

    <div v-if="role" style="width: 1056px;margin: 0 auto">
      <div class="goodslist_top">
        <div class="goodslist_title">筛选查询</div>
        <div class="goodslost_seach">
          <el-row class="goodslost_seach_row">
            <el-col :span="8">
              <div class="goodslost_seach_row_col">
                <div>公司名称:</div>
                <el-input placeholder="商品名称" v-model="sy_name" style="width:190px" size="small"></el-input>
              </div>
            </el-col>
            <el-col :span="8"></el-col>
            <el-col :span="8" style="text-align:center">
              <div>
                <el-button size="small" @click="seach()">搜索</el-button>
                <el-button size="small" @click="change_null">清空</el-button>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
      <div class="filtrate_center">
        <div class="center_list_head">
          <div class="center_list_head_left">
            <div style="margin-left:16px">
              <i class="fas fa-bars"></i>
              <span style="margin-left:6px">数据列表</span>
            </div>

            <div class="center_list_head_left_div">
              <div class="show_total">
                <el-dropdown trigger="click" @command="change_page_num">
                  <span class="el-dropdown-link show_total_span" style="c">
                    显示条数
                    <i style="font-size: 12px;" class="iconfont icon-sanjiaoxing"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item :command="10">每页10条</el-dropdown-item>
                    <el-dropdown-item :command="15">每页15条</el-dropdown-item>
                    <el-dropdown-item :command="20">每页20条</el-dropdown-item>
                    <el-dropdown-item :command="50">每页50条</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
              <div class="show_total" @click="dialogFormVisible1 = true">添加用户</div>
            </div>
          </div>
        </div>
        <div class="center_list_center"></div>
      </div>
      <el-table
        :header-cell-style="{'background':'#F5FAF9'}"
        v-loading="loading"
        :data="tableData"
        border
        style="width: 100%"
      >
        <el-table-column align="center" prop="order_by" label="排序" width="80"></el-table-column>
        <el-table-column align="center" prop="link_member" label="联系人" width="80"></el-table-column>
        <el-table-column
          align="center"
          prop="link_phone"
          label="联系电话"
          width="180"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column align="center" show-overflow-tooltip prop="main_product" label="主要产品"></el-table-column>
        <el-table-column align="center" prop="address" label="地址" show-overflow-tooltip></el-table-column>
        <el-table-column align="center" prop="company" label="公司名称" show-overflow-tooltip></el-table-column>
        <el-table-column align="center" prop="product_number" label="可上传商品数" show-overflow-tooltip></el-table-column>
        <el-table-column align="center" prop="username" label="登陆账号" show-overflow-tooltip></el-table-column>
        <el-table-column width="120" align="center" label="操作">
          <template slot-scope="scope">
            <span class="binaji" @click="setgoods(scope.row.id)">查看</span>
            <span class="binaji" @click="goodsdelete(scope.row.id)">{{scope.row.forbidden == '0' ? '禁用' : '开启'}}</span>
          </template>
        </el-table-column>
      </el-table>
      <div>
        <el-pagination
          class="goodslist_bom_page"
          hide-on-single-page
          background
          layout="total , prev, pager, next"
          :page-size="limit"
          :total="total"
          @current-change="pagechange"
        ></el-pagination>
        <!-- hide-on-single-page -->
      </div>
    </div>
    <noAccess v-else></noAccess>
    <!-- 添加用户 -->
    <el-dialog title="添加账户" :visible.sync="dialogFormVisible1" width="33%">
      <el-form>
        <el-form-item label="　　用户账号:">
          <el-input style="width:356px" v-model="shop_name" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="　　输入密码:">
          <el-input
            style="width:356px"
            type="password"
            v-model="pass"
            show-password
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="　　确认密码:">
          <el-input
            style="width:356px"
            type="password"
            v-model="pass1"
            show-password
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="　　公司名称:">
          <el-input style="width:356px" v-model="company" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="可上传商品数:">
          <el-input style="width:356px" v-model="product_number" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible1 = false">取 消</el-button>
        <el-button type="primary" @click="addsubmit()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "list",
  data() {
    return {
      role: true, 
      serve: this.$store.state.serve,
      sy_name: "",
      loading: false,
      shop_name: "",
      pass: "",
      pass1: "",
      company: "",
      product_number: "",
      serve: this.$store.state.serve,
      token: this.$cookies.get("token"),
      username: this.$cookies.get("username"),
      limit: 15,
      page: null,
      total: null,
      tableData: [],
      dialogFormVisible1: false
    };
  },
  created() {
    this.$store.state.topActiveId = 10;
    this.$store.state.leftTitle = "商户列表";
    this.geting();
  },
  watch: {},
  methods: {
    goodsdelete(id){
      this.axios.get(this.serve + 'admin/shopForbidden',{
        params:{
          username : this.username,
          token : this.token,
          id
        }
      }).then(res=>{
        if(res.data.status == 'success'){
          this.geting()
          this.$message({
            type : 'success',
            message : '操作成功'
          })
        }
      })
    },
    setgoods(id) {
      this.$router.push('/admin/shoplook/' + id)
    },
    seach() {
      this.geting();
    },
    change_null() {
      this.sy_name = "";
      this.geting();
    },
    pagechange(page) {
      this.geting(page);
    },
    change_page_num(v) {
      this.limit = v;
      this.geting();
    },
    addsubmit() {
      let config = {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      };
      const formData = new FormData();
      formData.append("username", this.username);
      formData.append("token", this.token);
      formData.append("shop_username", this.shop_name);
      formData.append("pass", this.pass);
      formData.append("pass2", this.pass1);
      formData.append("company", this.company);
      formData.append("product_number", this.product_number);
      this.axios
        .post(this.serve + "/admin/addShop", formData, config)
        .then(res => {
          if (res.data.status == "success") {
            this.geting();
            this.$message({
              type: "success",
              message: "操作成功"
            });
            this.dialogFormVisible1 = false;
          } else if (res.data.status == "error") {
            this.$message.error(res.data.msg);
          }
        });
    },
    geting(page) {
      this.loading = true;
      this.axios
        .get(this.serve + "/admin/shopList", {
          params: {
            username: this.username,
            token: this.token,
            page: page,
            limit: this.limit,
            company: this.sy_name
          }
        })
        .then(res => {
          if(res.data.code == '403'){
            this.role = false;
          }else{         
            this.tableData = [];
            this.loading = false;
            if (res.data.status == "success") {
              this.page = res.data.data.page;
              this.total = res.data.data.total;
              this.tableData = res.data.data.results;
            }
          }
        });
    }
  }
};
</script>
<style lang="scss">
.shop_list {
  background: #f5f5f5;
  color: #333;
  padding-bottom: 100px;
  min-height: 1000px;
  .binaji {
    cursor: pointer;
    margin-right: 10px;
    margin-left: 10px;
    font-weight: 300;
    font-size: 14px;
    color: rgba(51, 51, 51, 1);
    line-height: 18px;
  }
  .binaji:hover {
    color: #0099ff;
  }
  .goodslist_bom_page {
    //  height: 80px;
    padding: 13px 0 30px 0;
    text-align: right;
  }
  .topBar {
    margin-bottom: 40px;
  }
  .goodslist_top {
    border: 1px solid rgba(221, 221, 221, 1);
    .goodslist_title {
      border-bottom: 1px solid rgba(221, 221, 221, 1);
      width: 1022px;
      height: 46px;
      background: rgba(238, 238, 238, 1);
      font-size: 16px;
      font-family: "Microsoft YaHei";
      font-weight: 400;
      color: #333;
      line-height: 46px;
      padding-left: 16px;
      display: flex;
      justify-content: space-between;
      padding-right: 16px;
      align-items: center;
    }
    .goodslost_seach {
      // width: 1060px;
      // line-height: 86px;
      font-size: 16px;
      font-family: "Microsoft YaHei";
      font-weight: 300;
      color: rgba(51, 51, 51, 1);
      height: 86px;
      background: rgba(255, 255, 255, 1);
      display: flex;
      align-items: center;
      .goodslost_seach_row {
        width: 100%;
        .goodslost_seach_row_col {
          display: flex;
          align-items: center;
          justify-content: space-evenly;
        }
      }
    }
  }
  .filtrate_seek_sousuo {
    text-align: center;
    line-height: 28px;
    font-size: 14px;
    font-family: "MicrosoftYaHeiLight";
    font-weight: 300;
    color: rgba(102, 102, 102, 1);
    width: 74px;
    height: 28px;
    background: rgba(255, 255, 255, 1);
    border: 1px solid rgba(221, 221, 221, 1);
    position: absolute;
    right: 18px;
    top: 29px;
    cursor: pointer;
  }
  //   .el-pagination {
  //     text-align: left;
  //   }
  .filtrate_seek_sousuo:hover {
    background-color: #0099ff;
    color: #fff;
  }
  .subTitle {
    width: 1056px;
    margin: 0 auto;
    font-size: 14px;
    position: relative;
    .rutun {
      width: 78px;
      height: 28px;
      background: #fff;
      border: 1px solid rgba(221, 221, 221, 1);
      text-align: center;
      margin-top: 9px;
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      right: 0;
      top: 0;
      cursor: pointer;
    }
    .rutun:hover {
      color: #0099ff;
    }
  }
  .filtrate_center {
    margin-top: 19px;
    border-left: 1px solid rgba(221, 221, 221, 1);
    border-top: 1px solid rgba(221, 221, 221, 1);
    border-right: 1px solid rgba(221, 221, 221, 1);
  }
  .button1 {
    // border: 0;
    border: none;
    outline: none;
    background: none;
    font-size: 14px;
    font-family: "MicrosoftYaHeiLight";
    font-weight: 300;
    color: rgba(51, 51, 51, 1);
    line-height: 18px;
    cursor: pointer;
  }
  .button1:hover {
    color: #0099ff;
  }
  .el-row {
    display: flex;
    justify-content: center;
  }
  .cell {
    color: #606266 !important;
  }
  .center_list_head {
    width: 100%;
    height: 46px;
    // background: orange;
    //  display: flex;
    //  justify-content: space-between;
    .center_list_head_left {
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .center_list_head_left_div {
        display: flex;
      }
      .show_total {
        font-size: 12px;
        width: 100px;
        height: 30px;
        background: rgba(255, 255, 255, 1);
        border: 1px solid rgba(221, 221, 221, 1);
        text-align: center;
        cursor: pointer;
        line-height: 30px;
        margin-right: 4px;
      }
      .show_total:hover {
        color: #3498db;
      }
      .show_total_span:hover {
        color: #3498db;
      }
    }

    .center_list_head_rig:hover {
      color: #0099ff;
    }
  }

  .menu {
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
    .btn3 {
      i {
        font-style: normal;
        color: #f64e62;
      }
    }
    .btn3:hover i {
      color: #fff;
    }
  }
  .search .el-col {
    line-height: 80px;
  }
  .label {
    text-align: right;
    padding-right: 10px;
    font-size: 14px;
  }
  .table {
    background-color: #fff;
    padding: 10px 20px;
    .el-tree-node {
      font-size: 16px;
      padding: 5px 0;
    }
  }
  .el-table_1_column_3 .cell {
    overflow: hidden;
    text-align: center;
  }
}
</style>